import React from "react";
import { useNavigate } from "react-router-dom";
import { X, GitCompare } from "lucide-react";
import { Button } from "./ui/button";
import { useSearch } from "../context/SearchContext";

export const CompareTray = () => {
  const { compareIds, clearCompare } = useSearch();
  const navigate = useNavigate();
  if (compareIds.length === 0) return null;

  const ready = compareIds.length >= 2;

  return (
    <div
      className="fixed bottom-0 inset-x-0 z-50 border-t border-border bg-white/90 backdrop-blur-xl"
      data-testid="compare-tray"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-3 flex items-center justify-between gap-4">
        <div className="flex items-center gap-2 text-sm min-w-0">
          <GitCompare className="h-4 w-4 text-primary shrink-0" />
          <span className="font-medium shrink-0">{compareIds.length} selected</span>
          <span className="text-muted-foreground truncate">
            {ready ? "Compare up to 4 vehicles" : "Select one more vehicle to compare"}
          </span>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <Button variant="ghost" onClick={clearCompare} data-testid="compare-clear">
            <X className="h-4 w-4 mr-1" /> Clear
          </Button>
          {ready && (
            <Button
              className="bg-primary hover:bg-atlas-blue text-white"
              onClick={() => navigate("/compare")}
              data-testid="compare-go"
            >
              Compare now
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
